@if (!isDeactivated && isValidFitMenu()) {
    <div class="dropdown digi-fit-dropdown">
        <button (click)="openDropdown()"
                [disabled]="bookFeatureService.pageLinksDisabled"
                aria-expanded="true"
                aria-haspopup="true"
                class="btn btn-sm" type="button">
        </button>
        @if (dropdownShown || loading) {
            <div (click)="openDropdown()"
                 (wheel)="onScroll($event)"
                 [ngClass]="{'menu-content-right': pageService.isRightPage(page), 'menu-content-left': pageService.isLeftPage(page), 'display-bottom': !displayTop}"
                 [ngStyle]="{'height.px': contentPosition.h, 'width.px': contentPosition.w, 'left.px': contentPosition.x, 'top.px': contentPosition.y}" class="digi-fit-dropdown-content">
                @if (!assignment && loading) {
                    <app-loading-indicator/>
                }
                @if (dropdownShown && assignment) {
                    <lib-fit-menu #fitMenuContent
                                  (interaction)="interacted($event)"
                                  [bookIdentifier]="applicationStateService.bookConfig.quickLinkPrefix"
                                  [eBookPlus]="assignment.feature.eBookPlus"
                                  [featurePermissions]="applicationStateService.userData.permissions"
                                  [features]="assignment.feature.fitmenu"
                                  [embeddedIn]="Embedded.BOOKVIEWER"
                    />
                }
            </div>
        }
    </div>
}
